// The admin token is the server's own JWT from /api-admin/login/admin. It lives 7 days and the backend
// never revokes one, so it is good exactly when it parses and its exp is still ahead. Checking that here
// sends a returning admin with a dead token to the login page without waiting for a request (VLT-3185).
export function isAdminTokenUsable(token: string | null): boolean {
  try {
    const payload = JSON.parse(atob((token ?? '').split('.')[1].replace(/-/g, '+').replace(/_/g, '/')))
    return typeof payload.exp === 'number' && payload.exp * 1000 > Date.now()
  } catch {
    return false
  }
}
